var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowCircleRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-id": "background",
    fill: "transparent",
    fillRule: "nonzero",
    d: "M9 0a9 9 0 110 18A9 9 0 019 0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M9 .5a8.5 8.5 0 110 17 8.5 8.5 0 010-17z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": "arrow",
    fill: "#000",
    fillRule: "nonzero",
    d: "M7.5 6l4 3-4 3z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggZGF0YS1pZD0iYmFja2dyb3VuZCIgZmlsbD0idHJhbnNwYXJlbnQiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTksMCBDMTMuOTcwNTYyNywwIDE4LDQuMDI5NDM3MjUgMTgsOSBDMTgsMTMuOTcwNTYyNyAxMy45NzA1NjI3LDE4IDksMTggQzQuMDI5NDM3MjUsMTggMCwxMy45NzA1NjI3IDAsOSBDMCw0LjAyOTQzNzI1IDQuMDI5NDM3MjUsMCA5LDAgWiIvPgogICAgPHBhdGggc3Ryb2tlPSIjMDAwIiBkPSJNOSwwLjUgQzEzLjY5NDQyMDQsMC41IDE3LjUsNC4zMDU1Nzk2MyAxNy41LDkgQzE3LjUsMTMuNjk0NDIwNCAxMy42OTQ0MjA0LDE3LjUgOSwxNy41IEM0LjMwNTU3OTYzLDE3LjUgMC41LDEzLjY5NDQyMDQgMC41LDkgQzAuNSw0LjMwNTU3OTYzIDQuMzA1NTc5NjMsMC41IDksMC41IFoiLz4KICAgIDxwb2x5Z29uIGRhdGEtaWQ9ImFycm93IiBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHBvaW50cz0iNy41IDYgMTEuNSA5IDcuNSAxMiIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgArrowCircleRight as ReactComponent };